<template>
  <section class="yj-container" :class="{ 'is-vertical': isVertical }">
    <slot></slot>
  </section>
</template>

<script>
  export default {
    name: 'YjContainer',

    componentName: 'YjContainer',

    props: {
      direction: String
    },

    computed: {
      isVertical() {
        if (this.direction === 'vertical') {
          return true;
        } else if (this.direction === 'horizontal') {
          return false;
        }
        return this.$slots && this.$slots.default
          ? this.$slots.default.some(vnode => {
            const tag = vnode.componentOptions && vnode.componentOptions.tag;
            return tag === 'yj-header' || tag === 'yj-footer';
          })
          : false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/container/src/container.vue